module.exports = __webpack_public_path__ + "img/mobile_app.06f984e6.svg";